"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _styles = _interopRequireDefault(require("../styles"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes"];
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      position: 'relative',
      // Reset fieldset default style
      minWidth: 0,
      padding: 0,
      margin: 0,
      border: 0
    },
    marginNormal: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1)
    },
    marginDense: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0.5)
    },
    fullWidth: {
      width: _tokens.widthFluid
    }
  };
};

/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that state always stays consistent
 * across children.
 * @done true
 * @updated v7.0.0
 * @versionAdded v0.0.3
 * @examples
 *  ASimpleInput
 *  BulkFormGroupOrientation
 *  ContactFormDemo
 */
var FormControl = /*#__PURE__*/function (_React$Component) {
  function FormControl() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      adornedStart: false,
      filled: false,
      focused: false
    };
    return _this;
  }
  (0, _inheritsLoose2.default)(FormControl, _React$Component);
  var _proto = FormControl.prototype;
  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
      disabled = _this$props.disabled,
      error = _this$props.error,
      required = _this$props.required,
      margin = _this$props.margin;
    var _this$state = this.state,
      adornedStart = _this$state.adornedStart,
      filled = _this$state.filled,
      focused = _this$state.focused;
    return {
      muiFormControl: {
        adornedStart: adornedStart,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        margin: margin,
        onBlur: this.handleBlur,
        onEmpty: this.handleClean,
        onFilled: this.handleDirty,
        onFocus: this.handleFocus,
        required: required
      }
    };
  };
  _proto.render = function render() {
    var props = this.props;
    var classes = props.classes,
      other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    return /*#__PURE__*/_react.default.createElement(_material.FormControl, (0, _extends2.default)({
      classes: {
        root: classes.root,
        marginNormal: classes.marginNormal,
        marginDense: classes.marginDense,
        fullWidth: classes.fullWidth
      }
    }, other));
  };
  return FormControl;
}(_react.default.Component);
FormControl.muiName = 'FormControl';
FormControl.propTypes = {
  /**
   * The contents of the form control.
   */
  children: _propTypes.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),
  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,
  /**
  * The system prop that allows defining system overrides as well as additional CSS styles.
  */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false
};
FormControl.childContextTypes = {
  muiFormControl: _propTypes.default.object
};
var _default = exports.default = (0, _styles.default)(styles)(FormControl);